/**
 * Action types for AP GROUP SSID functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_AP_GROUP_SSID_LIST = 'GET_AP_GROUP_SSID_LIST';
export const GET_AP_GROUP_SSID_LIST_SUCCESS = 'GET_AP_GROUP_SSID_LIST_SUCCESS';
export const GET_AP_GROUP_SSID_LIST_FAIL = 'GET_AP_GROUP_SSID_SCHEDULER_FAIL';
export const DELETE_AP_GROUP_SSID = 'DELETE_AP_GROUP_SSID';
export const DELETE_AP_GROUP_SSID_SUCCESS = 'DELETE_AP_GROUP_SSID_SUCCESS';
export const DELETE_AP_GROUP_SSID_FAIL = 'DELETE_AP_GROUP_SSID_FAIL';
export const OPEN_AP_GROUP_SSID_MODAL = 'OPEN_AP_GROUP_SSID_MODAL';
export const ADD_AP_GROUP_SSID = 'ADD_AP_GROUP_SSID';
export const ADD_AP_GROUP_SSID_COMPLETE = 'ADD_AP_GROUP_SSID_COMPLETE';
export const EDIT_AP_GROUP_SSID = 'EDIT_AP_GROUP_SSID';
export const EDIT_AP_GROUP_SSID_COMPLETE = 'EDIT_AP_GROUP_SSID_COMPLETE';
export const RESET_ADD_AP_GROUP_SSID = 'RESET_ADD_AP_GROUP_SSID';
export const AP_GROUP_SSID_ADD_TRIGGER = 'AP_GROUP_SSID_ADD_TRIGGER';
